import ChangeEntityVisibilityContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/ChangeEntityVisibilityContent";
import AbstractCommand from "../../../core/application/AbstractCommand";
import NGTScenarioPlayer from "../../../ngt/scenario/NGTScenarioPlayer";
import DashboardEvent from "../../dashboard/event/DashboardEvent";
import InternalStakeholdersModel from "../../internal-stakeholders/model/InternalStakeholdersModel";
import StoryConventions from "../../story-conventions/StoryConventions";
import TeaCornerEvent from "../../tea-corner/event/TeaCornerEvent";
import TimerEvent from "../../timer/event/TimerEvent";

export default class HubAvailabilityCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {InternalStakeholdersModel} internalStakeholdersModel 
     */
    constructor(dispatcher, internalStakeholdersModel) {
        super(dispatcher);
        this._dispatcher = dispatcher;

        this._internalStakeholdersModel = internalStakeholdersModel;
    }

    execute(evt) {
        const data = evt.params.data;
        /** @type {ChangeEntityVisibilityContent} */
        const content = data.content;
        /** @type {NGTScenarioPlayer} */
        const contentPlayer = data.contentPlayer;

        const entityID = content.getEntityID();
        const visibilityEntity = content.getVisible();

        switch (entityID) {
            case StoryConventions.DASHBOARD_TITLE:
                const dashboardVisibilityEvent = visibilityEntity ? DashboardEvent.ENABLE_DASHBOARD_BUTTON : DashboardEvent.DISABLE_DASHBOARD_BUTTON;
                this._dispatcher.dispatch(dashboardVisibilityEvent);
                break;
            case StoryConventions.TEA_CORNER_TITLE:
                const teacornerVisibilityEvent = visibilityEntity ? TeaCornerEvent.ENABLE_TEA_CORNER_BUTTON : TeaCornerEvent.DISABLE_TEA_CORNER_BUTTON;
                this._dispatcher.dispatch(teacornerVisibilityEvent);
                break;
            default:
                const internalStakeholder = this._internalStakeholdersModel.getInternalStakeholderById(entityID);
                if (visibilityEntity) {
                    this._internalStakeholdersModel.activateInternalStakeholder(internalStakeholder);
                } else {
                    this._internalStakeholdersModel.deactivateInternalStakeholder(internalStakeholder);
                }
        }
        contentPlayer.contentCompleted(content);
    }
}